var React = require('react');

function CircleBorder (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("linearGradient",{"id":"circleBorderRadius","x1":"0%","y1":"0%","y2":"100%"},[React.createElement("stop",{"offset":"0%","stopColor":"#311B77","key":0}),React.createElement("stop",{"offset":"100%","stopColor":"#FF2DFF","key":1})])),React.createElement("circle",{"cx":"15","cy":"15","r":"14","fill":"none","fillRule":"evenodd","stroke":"url(#circleBorderRadius)","strokeWidth":"2","key":1})]);
}

CircleBorder.defaultProps = {"viewBox":"0 0 30 30"};

module.exports = CircleBorder;

CircleBorder.default = CircleBorder;
